import { render, staticRenderFns } from "./partNumberCell.vue?vue&type=template&id=6822e9ff&"
import script from "./partNumberCell.vue?vue&type=script&lang=js&"
export * from "./partNumberCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports